export enum EUserRole {
  B2BApplyer = 'b2b_applyer',
  InterventionHandler = 'intervention_handler',
  MagicAdmin = 'magic_admin',
  SuperAdmin = 'super_admin',
  UserManager = 'user_manager',
}
